<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('locations.locations')"
    class="manifest-location-filter"
    optional
  >
    <LocationFilter
      :id="inputId"
      v-model="location"
      :placeholder="t('locations.locations')"
      append-to="body"
    />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useModelValue } from '@rygen/rygen-ui/composables';

import { LocationFilters, ManifestSearchCriteria } from '@/model';

import LocationFilter from '@/components/search/LocationFilter.vue';
import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: ManifestSearchCriteria,
    default: () => new ManifestSearchCriteria(),
  },
});
const { id, modelValue } = toRefs(props);
const emit = defineEmits<{
  (event: 'update:model-value', newVal: ManifestSearchCriteria): void;
}>();
const { t } = useI18n();
const { internalValue } = useModelValue(modelValue, {
  emit,
  factoryMethod: (opts: Partial<ManifestSearchCriteria>) =>
    new ManifestSearchCriteria(opts),
});

const location = computed({
  get() {
    return new LocationFilters({
      locationId: internalValue.value.locationId,
      locationName: internalValue.value.locationName,
      locationCode: internalValue.value.locationCode,
      city: internalValue.value.city,
      state: internalValue.value.state,
      postalCode: internalValue.value.postalCode,
      country: internalValue.value.country,
    });
  },
  set(newVal: LocationFilters) {
    internalValue.value.locationId = newVal.locationId;
    internalValue.value.locationName = newVal.locationName;
    internalValue.value.locationCode = newVal.locationCode;
    internalValue.value.city = newVal.city;
    internalValue.value.state = newVal.state;
    internalValue.value.postalCode = newVal.postalCode;
    internalValue.value.country = newVal.country;
  },
});
</script>
